import axios from "axios";

// Actions
export const EXECUTE_REQUEST = "merge/EXECUTE_REQUEST";
export const EXECUTE_SUCCESS = "merge/EXECUTE_SUCCESS";
export const EXECUTE_FAILURE = "merge/EXECUTE_FAILURE";

// Reducer
const initialState = {
  loading: false,
  success: false,
  error: null,
  hasBeenRequested: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case EXECUTE_REQUEST:
      return { ...state, error: null, loading: true, hasBeenRequested: true };
    case EXECUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true
      };
    case EXECUTE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const executeRequest = () => ({
  type: EXECUTE_REQUEST
});

export const executeSuccess = () => ({
  type: EXECUTE_SUCCESS
});

export const executeFailure = error => ({
  type: EXECUTE_FAILURE,
  payload: error
});

/**
 * Initiates the merge of source account into target account.
 * Most information pertaining to the merge is contained in cookies and headers provided by gateway
 * so minimal data is included in the request.
 * @param {string} sourceUserId Id of the source account user to be merged into the target account.
 * Will be used to validate the source account token has not been altered.
 */
export const execute = sourceUserId => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();

  dispatch(executeRequest());
  try {
    await axios.post(`${api}/merge/execute`, {
      overrideWarningFlag: true,
      sourceUserId
    });

    dispatch(executeSuccess());
  } catch (error) {
    dispatch(executeFailure(error));
  }
};

// Selectors
export const getMergeExecuteLoading = state => state.merge.execute.loading;
export const getMergeExecuteError = state => state.merge.execute.error;
export const getMergeExecuteErrors = state =>
  state.merge.execute.error?.response?.data?.errors;
export const getMergeExecuteSuccess = state => state.merge.execute.success;
export const getMergeExecuteHasBeenRequested = state =>
  state.merge.execute.hasBeenRequested;
